(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_free-shipping-announcement"] && !Shopify.designMode) return;
  try {
    class FreeShippingLive extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      document.addEventListener('cart:update', this.refresh);
      document.addEventListener('discount:update', this.refresh);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this.refresh);
      document.removeEventListener('discount:update', this.refresh);
      this.controller?.abort();
    }

    async refresh() {
      const { sectionId, blockId } = this.dataset;
      if (!sectionId || !blockId) return;

      this.controller?.abort();
      this.controller = new AbortController();

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}?section_id=${encodeURIComponent(sectionId)}`, {
          signal: this.controller.signal,
          cache: 'no-store',
        });
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector(`free-shipping-live[data-block-id="${blockId}"]`);
        if (fresh) this.innerHTML = fresh.innerHTML;
      } catch (error) {
        if (error.name !== 'AbortError') console.error('[free-shipping-live]', error);
      }
    }
  }

  if (!customElements.get('free-shipping-live')) {
    customElements.define('free-shipping-live', FreeShippingLive);
  }
  } catch(e) { console.error(e); }
})();

})();
